<div class="container" *ngIf="dfmData">
    <div class="dfm-container" >
        <h2 class="title">{{ dfmData.title }}</h2>
        <p class="copy">{{ dfmData.copy }}</p>
        <finder-picture *ngIf="dfmImage"
            aria-hidden="true"
            [picture]="dfmImage">
        </finder-picture>
    </div>
</div>
